/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BatchWriteSupport } from './BatchWriteSupport';
import {
    BatchWriteSupportFromJSON,
    BatchWriteSupportFromJSONTyped,
    BatchWriteSupportToJSON,
} from './BatchWriteSupport';
import type { BulkWriteSupport } from './BulkWriteSupport';
import {
    BulkWriteSupportFromJSON,
    BulkWriteSupportFromJSONTyped,
    BulkWriteSupportToJSON,
} from './BulkWriteSupport';
import type { SearchSupport } from './SearchSupport';
import {
    SearchSupportFromJSON,
    SearchSupportFromJSONTyped,
    SearchSupportToJSON,
} from './SearchSupport';
import type { SubscribeSupport } from './SubscribeSupport';
import {
    SubscribeSupportFromJSON,
    SubscribeSupportFromJSONTyped,
    SubscribeSupportToJSON,
} from './SubscribeSupport';

/**
 * The supported features for the provider.
 * @export
 * @interface Support
 */
export interface Support {
    /**
     * 
     * @type {BulkWriteSupport}
     * @memberof Support
     */
    bulkWrite: BulkWriteSupport;
    /**
     * 
     * @type {boolean}
     * @memberof Support
     */
    proxy: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Support
     */
    read: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Support
     */
    subscribe: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Support
     */
    write: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Support
     */
    _delete: boolean;
    /**
     * 
     * @type {SubscribeSupport}
     * @memberof Support
     */
    subscribeSupport?: SubscribeSupport;
    /**
     * 
     * @type {BatchWriteSupport}
     * @memberof Support
     */
    batchWrite?: BatchWriteSupport;
    /**
     * 
     * @type {SearchSupport}
     * @memberof Support
     */
    search: SearchSupport;
}

/**
 * Check if a given object implements the Support interface.
 */
export function instanceOfSupport(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "bulkWrite" in value;
    isInstance = isInstance && "proxy" in value;
    isInstance = isInstance && "read" in value;
    isInstance = isInstance && "subscribe" in value;
    isInstance = isInstance && "write" in value;
    isInstance = isInstance && "_delete" in value;
    isInstance = isInstance && "search" in value;

    return isInstance;
}

export function SupportFromJSON(json: any): Support {
    return SupportFromJSONTyped(json, false);
}

export function SupportFromJSONTyped(json: any, ignoreDiscriminator: boolean): Support {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bulkWrite': BulkWriteSupportFromJSON(json['bulkWrite']),
        'proxy': json['proxy'],
        'read': json['read'],
        'subscribe': json['subscribe'],
        'write': json['write'],
        '_delete': json['delete'],
        'subscribeSupport': !exists(json, 'subscribeSupport') ? undefined : SubscribeSupportFromJSON(json['subscribeSupport']),
        'batchWrite': !exists(json, 'batchWrite') ? undefined : BatchWriteSupportFromJSON(json['batchWrite']),
        'search': SearchSupportFromJSON(json['search']),
    };
}

export function SupportToJSON(value?: Support | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bulkWrite': BulkWriteSupportToJSON(value.bulkWrite),
        'proxy': value.proxy,
        'read': value.read,
        'subscribe': value.subscribe,
        'write': value.write,
        'delete': value._delete,
        'subscribeSupport': SubscribeSupportToJSON(value.subscribeSupport),
        'batchWrite': BatchWriteSupportToJSON(value.batchWrite),
        'search': SearchSupportToJSON(value.search),
    };
}

